import { render, staticRenderFns } from "./MultiInputComponent.vue?vue&type=template&id=0bbb8cdc&scoped=true"
import script from "./MultiInputComponent.vue?vue&type=script&lang=js"
export * from "./MultiInputComponent.vue?vue&type=script&lang=js"
import style0 from "./MultiInputComponent.vue?vue&type=style&index=0&id=0bbb8cdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbb8cdc",
  null
  
)

export default component.exports